<template>
  <div class="iframe">
    <div class="top">
      <div class="note">
        右侧有三种不同难度的选项，你可以从中选取一个或者多个适合你的难度进行挑战，比赛结果将综合挑战难度以及完成情况进行评分。
        <div class="timer">比赛时间还剩 <span class="color">{{timer}}</span></div>
        <div>
          比赛中成绩是实时记录的，倒计时结束后比赛会自动结束，可以关闭浏览器离开考场。
        </div>
        <div>
          注：如果点击按钮一段时间后出现页面未加载完成的情况，可以点击其他按钮切换页面重试。
        </div>
      </div>
      <div class="options">
        <div class="numbers">
          腾讯会议号码
          <span class="number" v-for="(num, index) in meetings">{{num}} </span>
        </div>
        <my_button v-for="u in urls" :value="u.text" :inputStyle="buttonStyle" @click.native="jump(u)"></my_button>
      </div>
    </div>
    <vue_friendly_iframe :src="src"></vue_friendly_iframe>
  </div>
</template>

<script>
import VueFriendlyIframe from 'vue-friendly-iframe';
import MyButton from '@/components/Button.vue';
import moment from 'moment';
export default {
  name: 'playPageplay',
  data () {
    return {
      base: 'https://koudashijie.com',
      src: 'about:blank',
      now: new Date(),
      problem_urls: [],
      urls: [
      ],
      meetings: [
        '360819105'
      ]
    }
  },
  methods : {
    jump (u) {
      let url = this.$store.state.loginLink + `&redirect=${encodeURIComponent(u.url)}` + `&accessToken=${this.$store.state.auth.token.token}`
      this.src = url
    }
  },
  mounted () {
    let classrooms = this.$http.get('/api/final/joined-classroom').then(res => {
      this.$store.commit("SET_CLASSROOMS", res.data)
    })
    const textMap = {
      intro: '计算机科学1',
      'course-2': '计算机科学2',
      'course-3': '计算机科学3',
      'course-4': '计算机科学4',
      'course-5': '计算机科学5',
      'course-6': '计算机科学6',
      'game-dev-2': '游戏开发2',
      'game-dev-3': '游戏开发3',
    }
    this.$http.get('/api/me/plus_problems').then(res=> {
      res.data.forEach(url => {
        const key =url.match(/\/play\/(.*?)\?/)?.[1]
        this.urls.push({
          url, text: textMap[key]
        })
      })
      this.src=this.$store.state.loginLink+`&redirect=${encodeURIComponent(this.urls[0].url)}&accessToken=${this.$store.state.auth.token.token}`
    })
    setInterval(() => {
      this.now = moment(+new Date() + this.$store.state.timeDelay)
    }, 1000)
  },
  computed: {
    buttonStyle() {
      return {
        'border-radius': '5px',
        'margin-top': '5px',
        'padding': '5px',
        'margin-right': '5px',
        'height': '50px',
        'font-size': '16px',
        'width': '8em'
      }
    },
    classroomDate () {
      const classrooms = this.$store.state.classrooms
      if (classrooms.length) {
        return classrooms[0].succeeded_at
      }
      return null
    },
    timer () {
      if (!this.classroomDate) {
        return '00:00'
      }
      const diff = moment.duration(moment(this.classroomDate).add(1, 'hours').diff(this.now))
      return moment.utc(diff.asMilliseconds()).format("HH:mm:ss");
    }
  },
  watch:  {
    now () {
      if (this.classroomDate) {
        const diff = moment(this.classroomDate).add(1, 'hours').isBefore(this.now)
        if (diff) {
          this.$router.push({name: 'frontpage'})
        }
      }
    }
  },
  components: {
    vue_friendly_iframe: VueFriendlyIframe,
    my_button: MyButton,
  },
}
</script>

<style scoped>
.iframe {
  width: 90vw;
  min-width: 1080px;
  max-width: 100vw;
  font-size: 20px;
}
.top {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.options {
  margin-left: 50px;
}

.color {
  color: #fa5151;
}
.numbers {
  flex-wrap: wrap;
}
.number {
  margin-left: 20px;
  margin-right: 10px;
}
>>> iframe {
  width: 100%;
  height: 84vh
}
</style>
